// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchBox_searchContainer_2gmZ4"};